import Vue from 'vue'
import ValidateInput from '@/components/ValidatedInput'

Vue.component('v-input', ValidateInput);